import { PatientCreateSimpleCommand, PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';
import { commonTranslationKeys } from '@dreryk/react-common';

import { translationKeys } from './translations';
import { PatientSimpleCreateFormController, PatientSimpleCreateFormFormBean } from './PatientSimpleCreateForm.types';

type PatientSimpleCreateModalConfirmButtonProps = {
   handleSubmit: PatientSimpleCreateFormController['handleSubmit'];
   onSuccess: (patient: PatientSimple) => void;
};

export const PatientSimpleCreateModalConfirmButton = (
   props: PatientSimpleCreateModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: createPatient } = useCqrsCommand<PatientSimple, PatientSimpleCreateFormFormBean>(
      (parameters) => {
         const command = new PatientCreateSimpleCommand();
         command.firstName = Choice.withUseDefaultIfNull(parameters.firstName);
         command.lastName = Choice.withUseDefaultIfNull(parameters.lastName);
         command.phoneNumber = Choice.withUseDefaultIfNull(parameters.phoneNumber);
         return command;
      },
      {
         onSuccess: (patient) => {
            props.onSuccess(patient);
            dispatchSnackbarPositiveEvent(translationKeys.successullyAddedPatient);
         },
      }
   );

   return <ModalConfirmButton label={commonTranslationKeys.save} onClick={props.handleSubmit(createPatient)} />;
};
